module.exports = __webpack_public_path__ + "img/pijltje-klein-rechts.e658c1ae70d67b6981842cfa0b40801f.svg";